module.exports = __webpack_public_path__ + "static/Elbil_hovedbilde4-58b6f6a0809f1c8b61a1641d840272fb.png";